var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 19.8 120 39.6 120 60 C80.4 60 40.8 60 0 60 C0 40.2 0 20.4 0 0 Z ",
    fill: "#0000FE",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 6.6 120 13.2 120 20 C80.4 20 40.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FF0000",
    transform: "translate(0,40)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 6.6 120 13.2 120 20 C92.94 20 65.88 20 38 20 C37.505 16.04 37.505 16.04 37 12 C34.17283905 11.05761302 32.36823877 10.86534353 29.4375 10.875 C28.25994141 10.87113281 28.25994141 10.87113281 27.05859375 10.8671875 C24.93561023 10.87023634 24.93561023 10.87023634 23 12 C22.67 14.64 22.34 17.28 22 20 C14.74 20 7.48 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.76183594 -0.00515625 1.52367187 -0.0103125 2.30859375 -0.015625 C4.77693018 0.2752708 6.420186 1.02024344 8.5625 2.25 C8.88547455 8.30278224 9.08583984 13.03023727 5.5625 18.25 C2.5625 20.25 2.5625 20.25 0.125 20.125 C-2.9720773 19.06746141 -4.3695717 17.76105579 -6.4375 15.25 C-7.4113963 12.32831111 -7.63355823 10.23970526 -7.6875 7.1875 C-7.71328125 6.30964844 -7.7390625 5.43179687 -7.765625 4.52734375 C-7.65734375 3.77582031 -7.5490625 3.02429688 -7.4375 2.25 C-4.32763793 0.17675862 -3.54641613 -0.02392186 0 0 Z ",
    fill: "#9557C1",
    transform: "translate(29.4375,9.75)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.17369141 -0.00386719 1.17369141 -0.00386719 2.37109375 -0.0078125 C4.5625 0.125 4.5625 0.125 7.5625 1.125 C7.8125 8.75 7.8125 8.75 5.5625 12.125 C5.2325 11.465 4.9025 10.805 4.5625 10.125 C3.5725 9.795 2.5825 9.465 1.5625 9.125 C1.5625 8.465 1.5625 7.805 1.5625 7.125 C0.9025 7.125 0.2425 7.125 -0.4375 7.125 C-0.4375 7.785 -0.4375 8.445 -0.4375 9.125 C-1.4275 9.455 -2.4175 9.785 -3.4375 10.125 C-4.0975 10.785 -4.7575 11.445 -5.4375 12.125 C-6.72067892 8.27546324 -6.50393637 5.17761865 -6.4375 1.125 C-4.08479407 -0.05135297 -2.616748 -0.00859359 0 0 Z ",
    fill: "#0807FD",
    transform: "translate(29.4375,9.875)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0.495 2.97 0.495 6 1 C6.93423645 4.01031744 7.04449911 4.86650268 6 8 C5.01 8.33 4.02 8.66 3 9 C2.34 9.66 1.68 10.32 1 11 C-0.28317892 7.15046324 -0.06643637 4.05261865 0 0 Z ",
    fill: "#0706FC",
    transform: "translate(23,11)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C2.9590625 2.1546875 2.9590625 2.1546875 3.9375 2.3125 C4.618125 2.539375 5.29875 2.76625 6 3 C6.33 3.99 6.66 4.98 7 6 C3.26562152 6.87867729 -0.16774573 7.08912219 -4 7 C-4.33 6.34 -4.66 5.68 -5 5 C-4.34 4.01 -3.68 3.02 -3 2 C-2.01 2 -1.02 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#EDEDFF",
    transform: "translate(29,17)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C8.67 0.99 8.34 1.98 8 3 C7.34 3 6.68 3 6 3 C6 3.66 6 4.32 6 5 C5.34 5 4.68 5 4 5 C4 4.01 4 3.02 4 2 C2.68 1.34 1.36 0.68 0 0 Z ",
    fill: "#3939D9",
    transform: "translate(25,10)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSl);
export default __webpack_public_path__ + "static/media/sl.ae3402b755526ba6b7b62334840070ee.svg";
export { ForwardRef as ReactComponent };